/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52daaed06cf97081001da5ab5b2aa975>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const MagicWandIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m9.25 8.75-6.058 6.058a.625.625 0 0 1-.884 0l-1.116-1.116a.625.625 0 0 1 0-.884L7.25 6.75m2 2 2.058-2.058a.625.625 0 0 0 0-.884l-1.116-1.116a.625.625 0 0 0-.884 0L7.25 6.75m2 2-2-2M10.75 0v2m2.298.952 1.414-1.414M14 5.25h2M7.038 1.538l1.414 1.414m4.596 4.596 1.414 1.414"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
MagicWandIcon.displayName = 'MagicWandIcon';
var _default = exports.default = MagicWandIcon;